$(function () {
    var scroll = 0;
    $(".gallery-button").on("click", function (evt) {
        $(".gallery-container").removeClass("hidden");
        $(".gallery-container .gallery-content").slick({
            dots: false,
            infinite: false,
            slidesToShow: 1.40,
            slidesToScroll: 1,
            prevArrow: $(".gallery-arrow-prev"),
            nextArrow: $(".gallery-arrow-next"),
            responsive: [
              {
                breakpoint: 1000,
                settings: "unslick"
              }
            ]
          });
        scroll = $(window).scrollTop();
        $(window).scrollTop(0);
        $("body").css("overflow-y", "hidden");
        $(".wrp-header").addClass("hidden");
    })
    
    $(".bottone-chiudi-gallery").on("click", function (evt) {
        chiudiGallery();
    })
})

function chiudiGallery () {
    $('.gallery-container .gallery-content').slick('unslick');
    $(".gallery-container").addClass("hidden");
    $(window).scrollTop(scroll);
    $("body").css("overflow-y", "auto");
    $(".wrp-header").removeClass("hidden");
}